import {BaseAppModel} from "@/model/AppModel";

export default class Advertisement extends BaseAppModel<Advertisement> {
    tag!: string
    url!: string
    imgUrl!: string
}